/** Actions triggered from the mobile nav footer and handled by the top bar account menu. */
export const AccountMenuAction = {
  /** Opens the company switcher from the mobile nav footer. */
  Switch: 'switch',

  /** Starts the change-password flow from the mobile nav footer. */
  Password: 'password'
} as const;

export type AccountMenuAction = (typeof AccountMenuAction)[keyof typeof AccountMenuAction];

/** Viewport width at or below which the app uses the mobile drawer navigation. */
export const MOBILE_LAYOUT_MEDIA_QUERY = '(max-width: 768px)';
